export default "data:image/svg+xml,no.svg"